import { IonTextareaCustomEvent } from '@ionic/core';
import { IonItem, IonTextarea, TextareaChangeEventDetail } from '@ionic/react';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { TEST_IDS } from '../../../../config/utils/constants';

interface Props {
  fieldName: any;
  formik: any;
  index: number;
}

export const DocProductDescription = ({ fieldName, formik, index }: Props) => {
  const { t } = useTranslation();
  const formName = `products[${index}][${fieldName}]`;
  const isProductsSectionDisabled = useMemo(() => !!formik?.errors?.customerId, [formik?.errors]);

  const onChange = useCallback(
    (event: IonTextareaCustomEvent<TextareaChangeEventDetail>) => {
      const valueWithoutNewLines = event?.target?.value?.replace(/\n/g, ' ');
      event.target.value = valueWithoutNewLines;

      formik.handleChange(event);
    },
    [formik],
  );

  return (
    <div>
      <IonItem
        id={`product_${fieldName}_${index}`}
        className="width-300px border-radius-input g-select-border cursorPointer"
        mode="md">
        <IonTextarea
          id={`${TEST_IDS.Invoice.productDescriptionInput}_${index + 1}`}
          disabled={isProductsSectionDisabled}
          mode="md"
          name={formName}
          aria-label="description"
          // See `CustomerSimpleInput.tsx` re: `ionInput` vs `ionChange`.
          onIonInput={onChange}
          placeholder={t('SALE.DESCRIPTION') + '...'}
          value={formik.values?.products[index]?.[fieldName]}
          maxlength={299}
          autoGrow={true}
        />
      </IonItem>
    </div>
  );
};
